<template>
    <div class="index" id="wrapper" style="margin-top:0;">
    <app-header />
    <section class="section-1" id="huan10_22" style="overflow: hidden;">
      <div class="Ppictxt">
      </div>
      <!-- <div id="canvas"></div> -->
    </section>
    <div id="main">
      <!-- 人体健康认知与疾病筛查预测系统 -->
      <section class="content-wrap section">
        <div class="content-w">
          <div class="content-txt" style="display: none;">智能认知系统</div>
          <h3><span>人体医学生物特征诊断分析系统</span></h3>
          <ul class="cont-list">
            <li>
              <div class="cont-list-info">
                <div><img src="../assets/img/jb_pic1.jpg"></div>
                <h5>体相认知与疾病筛查</h5>
              </div>
              <div class="cont-list-main">
                <div class="cont-list-mt">
                  <strong>体相认知与疾病筛查</strong>
                  <p>体相认知与疾病筛查包括对舌头、嘴唇、眼睛、耳朵、鼻子、面部等多种体相信息认知</p>
                </div>
                <div class="mask"></div>
              </div>
            </li>
            <li>
              <div class="cont-list-info">
                <div><img src="../assets/img/jb_pic2.jpg"></div>
                <h5>征兆认知与疾病筛查</h5>
              </div>
              <div class="cont-list-main">
                <div class="cont-list-mt">
                  <strong>征兆认知与疾病筛查</strong>
                  <p>包括对性病、皮肤病、妇科病等病征信息的认知分析与筛查</p>
                </div>
                <div class="mask"></div>
              </div>
            </li>
            <li>
              <div class="cont-list-info">
                <div><img src="../assets/img/jb_pic3.jpg"></div>
                <h5>病理认知与疾病筛查</h5>
              </div>
              <div class="cont-list-main">
                <div class="cont-list-mt">
                  <strong>病理认知与疾病筛查</strong>
                  <p>包括对尿常规、便常规等病理检查信息的认知分析与筛查</p>
                </div>
                <div class="mask"></div>
              </div>
            </li>
            <li>
              <div class="cont-list-info">
                <div><img src="../assets/img/jb_pic4.jpg"></div>
                <h5>生理认知与疾病筛查</h5>
              </div>
              <div class="cont-list-main">
                <div class="cont-list-mt">
                  <strong>生理认知与疾病筛查</strong>
                  <p>包括对气味、声音、形态等生理表现信息的认知分析与筛查</p>
                </div>
                <div class="mask"></div>
              </div>
            </li>
            <li>
              <div class="cont-list-info">
                <div><img src="../assets/img/jb_pic5.jpg"></div>
                <h5>心理认知与疾病筛查</h5>
              </div>
              <div class="cont-list-main">
                <div class="cont-list-mt">
                  <strong>心理认知与疾病筛查</strong>
                  <p>包括对焦虑、抑郁等心理信息的认知分析与筛查疾病认知辅助诊断系统</p>
                </div>
                <div class="mask"></div>
              </div>
            </li>
          </ul>
        </div>
      </section>
      <!-- 疾病认知辅助诊断系统 -->
      <section class="content-wrap">
        <div class="content-w">
          <h3><span>AIOT智能认知管理系统</span></h3>
          <ul class="cont-list">
            <li>
              <div class="cont-list-info">
                <div class=""><img src="../assets/img/prod_pic06.jpg"></div>
                <h5>血压认知与疾病筛查</h5>
              </div>
              <div class="cont-list-main">
                <div class="cont-list-mt">
                  <strong>血压认知与疾病筛查</strong>
                  <p>通过智能认知技术对血压监测信息进行分析，给出监测预警提醒及可能存在的疾病分析，帮助用户筛查身体疾病，提出解决方法。</p>
                </div>
                <div class="mask"></div>
              </div>
            </li>
            <li>
              <div class="cont-list-info">
                <div class=""><img src="../assets/img/prod_pic07.jpg"></div>
                <h5>血糖认知与疾病筛查</h5>
              </div>
              <div class="cont-list-main">
                <div class="cont-list-mt">
                  <strong>血糖认知与疾病筛查</strong>
                  <p>通过智能认知技术对血糖监测信息进行分析，给出监测预警提醒及可能存在的疾病分析，帮助用户筛查身体疾病，提出解决方法。</p>
                </div>
                <div class="mask"></div>
              </div>
            </li>
            <li>
              <div class="cont-list-info">
                <div class=""><img src="../assets/img/prod_pic10.jpg"></div>
                <h5>尿酸认知与疾病筛查</h5>
              </div>
              <div class="cont-list-main">
                <div class="cont-list-mt">
                  <strong>尿酸认知与疾病筛查</strong>
                  <p>通过智能认知技术对血尿酸监测信息进行分析，给出监测预警提醒及可能存在的疾病分析，帮助用户筛查身体疾病，提出解决方法。</p>
                </div>
                <div class="mask"></div>
              </div>
            </li>
            <li>
              <div class="cont-list-info">
                <div class=""><img src="../assets/img/prod_pic08.jpg"></div>
                <h5>血脂认知与疾病筛查</h5>
              </div>
              <div class="cont-list-main">
                <div class="cont-list-mt">
                  <strong>血脂认知与疾病筛查</strong>
                  <p>通过智能认知技术对血脂监测信息进行分析，给出监测预警提醒及可能存在的疾病分析，帮助用户筛查身体疾病，提出解决方法。</p>
                </div>
                <div class="mask"></div>
              </div>
            </li>
            <li>
              <div class="cont-list-info">
                <div class=""><img src="../assets/img/prod_pic09.jpg"></div>
                <h5>血氧认知与疾病筛查等</h5>
              </div>
              <div class="cont-list-main">
                <div class="cont-list-mt">
                  <strong>血氧认知与疾病筛查等</strong>
                  <p>通过智能认知技术对血氧监测信息进行分析，给出监测预警提醒及可能存在的疾病分析，帮助用户筛查身体疾病，提出解决方法。</p>
                </div>
                <div class="mask"></div>
              </div>
            </li>
          </ul>
        </div>
      </section>
      <!-- 环境认知与疾病预警预测系统 -->
      <section class="content-wrap">
        <div class="content-w">
          <h3><span>环境认知与疾病预警预测系统</span></h3>
          <div class="z-ai-warp">
            <div class="z-ai-tab clear" style="display: ;">
              <span class="active">室内温湿度与致病病菌预测预警系统</span>
              <span>发热门诊辅助诊断智能筛查助手</span>
              <span>行业热成像人体测温初筛系统</span>
            </div>
            <div class="z-ai-cont">
              <div class="z-ai-list bg-1 zshow">
                <p>该系统是一套适用于居家、学校、机关、养老院、医院、办公场所室内温湿度与病菌致病风险远程监测预警系统，可以实现上述场所室内温湿度全天候不间断的实时监测、报警、记录和数据存储、查询，并可以实时提供致病病菌生长繁殖指数分析和风险预警。</p>
              </div>
              <div class="z-ai-list bg-2">
                <p>该系统是一套适用于发热门诊的辅助诊断智能筛查助手，可以通过设备快速提取监测对象体温信息，根据患者症状立刻给出诊断筛查结果，提高发热门诊诊断效率，减轻发热门诊医护人员工作压力。</p>
              </div>
              <div class="z-ai-list bg-3">
                <p>该系统可以在公共场所如医院、学校、车站、等场所，通过选择采用非接触式体温测量方式，用于对出入口行人进行快速测量，及时发现体温异常人员，执行快速干预手段，防止病毒疫情在公共场所下出现大范围感染人员扩散的危险。</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 智能认知产品 -->
      <section class="content-wrap cbg section">
        <div class="content-w pro-tab" id="proinfo">
          <div class="content-txt myfont">AIOT智能认知产品</div>
          <!--  -->
          <div class="min_pic clear">
            <div class="nextbut prev_btn1" id="prev_btn1"></div>
            <div class="num clearfix" id="ban_num1">
              <ul>
                <li>
                  <a href="javascript:;">
                    <img src="../assets/img/RZ_pic01.png" width="80" height="80" alt="">
                  </a>
                  <div class="pro-name-txt">
                    <div>
                      <p>UVC紫外线杀毒棒<br />(通用款)</p>
                    </div>
                  </div>
                </li>
                <li>
                  <a href="javascript:;">
                    <img src="../assets/img/RZ_pic02.png" width="80" height="80" alt="">
                  </a>
                  <div class="pro-name-txt">
                    <div>
                      <p>UVC紫外线杀毒棒<br />(便携款)</p>
                    </div>
                  </div>
                </li>
                <li>
                  <a href="javascript:;">
                    <img src="../assets/img/RZ_pic03.png" width="80" height="80" alt="">
                  </a>
                  <div class="pro-name-txt">
                    <div>
                      <p>UVC紫外线杀毒棒<br />(手机款)</p>
                    </div>
                  </div>
                </li>
                <li>
                  <a href="javascript:;">
                    <img src="../assets/img/RZ_pic04.png" width="80" height="80" alt="">
                  </a>
                  <div class="pro-name-txt">
                    <div>
                      <p>室内温湿度监测仪</p>
                    </div>
                  </div>
                </li>
                <li>
                  <a href="javascript:;">
                    <img src="../assets/img/RZ_pic05.png" width="80" height="80" alt="">
                  </a>
                  <div class="pro-name-txt">
                    <div>
                      <p>空气魔盒</p>
                    </div>
                  </div>
                </li>
                <li>
                  <a href="javascript:;">
                    <img src="../assets/img/RZ_pic06.png" width="80" height="80" alt="">
                  </a>
                  <div class="pro-name-txt">
                    <div>
                      <p>吾征高血压<br />智能认知仪</p>
                    </div>
                  </div>
                </li>
                <li>
                  <a href="javascript:;">
                    <img src="../assets/img/RZ_pic07.png" width="80" height="80" alt="">
                  </a>
                  <div class="pro-name-txt">
                    <div>
                      <p>吾征高血糖<br />智能认知仪</p>
                    </div>
                  </div>
                </li>
                <li>
                  <a href="javascript:;">
                    <img src="../assets/img/RZ_pic08.png" width="80" height="80" alt="">
                  </a>
                  <div class="pro-name-txt">
                    <div>
                      <p>吾征智能三合一</p>
                    </div>
                  </div>
                </li>
                <li>
                  <a href="javascript:;">
                    <img src="../assets/img/RZ_pic09.png" width="80" height="80" alt="">
                  </a>
                  <div class="pro-name-txt">
                    <div>
                      <p>智能认知血糖仪<br />高端礼盒</p>
                    </div>
                  </div>
                </li>
                <li>
                  <a href="javascript:;">
                    <img src="../assets/img/RZ_pic10.png" width="80" height="80" alt="">
                  </a>
                  <div class="pro-name-txt">
                    <div>
                      <p>智能认知血脂仪<br />高端礼盒</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="nextbut next_btn1" id="next_btn1"></div>
          </div>
          <div class="ban2" id="ban_pic1">
            <ul>
              <li>
                <div class="pro-intro">
                  <img src="../assets/img/aRZ_pic01.jpg">
                </div>
                <div class="pro-introtxt">
                  <h4>UVC紫外线杀毒棒(通用款)</h4>
                  <p>适用于各种场合、环境的消毒需求，无需接触化学试剂。轻轻扫一扫，就能起到99.9%的杀菌消毒作用。</p>
                  <p>“UVC紫外线杀毒棒”通过200-280nm的紫外光，对病菌、病毒进行灭活，尤其是在新冠肺炎疫情期间，对新冠病毒有很好的消杀作用。</p>
                </div>
              </li>
              <li>
                <div class="pro-intro">
                  <img src="../assets/img/aRZ_pic02.jpg">
                </div>
                <div class="pro-introtxt">
                  <h4>UVC紫外线杀毒棒(便携款)</h4>
                  <p>外观精美方便携带，适用于外出接触随时可以进行消毒，无需接触化学试剂。轻轻扫一扫，就能起到99.9%的杀菌消毒作用。</p>
                  <p>“UVC紫外线杀毒棒”通过200-280nm的紫外光，对病菌、病毒进行灭活，尤其是在新冠肺炎疫情期间，对新冠病毒有很好的消杀作用。</p>
                </div>
              </li>
              <li>
                <div class="pro-intro">
                  <img src="../assets/img/aRZ_pic03.jpg">
                </div>
                <div class="pro-introtxt">
                  <h4>UVC紫外线杀毒棒(手机款)</h4>
                  <p>身材小巧方便携带，无需充电，只需连接手机插口，无需接触化学试剂。轻轻扫一扫，就能起到99.9%的杀菌消毒作用。</p>
                  <p>“UVC紫外线杀毒棒”通过200-280nm的紫外光，对病菌、病毒进行灭活，尤其是在新冠肺炎疫情期间，对新冠病毒有很好的消杀作用。</p>
                </div>
              </li>
              <li>
                <div class="pro-intro">
                  <img src="../assets/img/aRZ_pic04.jpg">
                </div>
                <div class="pro-introtxt">
                  <h4>室内温湿度监测仪</h4>
                  <p>许多疾病的高发与室内外温湿度有密切关系，所以科学调节室内温湿度，预防可能的疾病风险，对身体健康具有重大意义。“wz0001型室内温湿度监测仪”可以实时监测室内温湿度、室内外温差变化情况，实时预警监测环境信息。更可以在APP查看“室内温湿度与病菌疾病风险智能预警系统”分析报告。</p>
                </div>
              </li>
              <li>
                <div class="pro-intro">
                  <img src="../assets/img/aRZ_pic05.jpg">
                </div>
                <div class="pro-introtxt">
                  <h4>空气魔盒</h4>
                  <p>通过实时监测室内温湿度、室内外温差及室内pm2.5浓度给用户提供及时的环境预警及改善方案，只需轻轻用手划过魔盒顶部，就可以获得当前环境信息。更可以在APP查看“室内温湿度与病菌致病风险智能预警系统”分析报告。</p>
                </div>
              </li>
              <li>
                <div class="pro-intro">
                  <img src="../assets/img/aRZ_pic06.jpg">
                </div>
                <div class="pro-introtxt">
                  <h4>吾征高血压智能认知仪</h4>
                  <p>不只是一个“血压测量仪”！</p>
                  <p>我们在测量用户血压数据同时，对用户血压数据进行智能认知分析，结合用户身体情况做出预警提醒，通过吾征AI APP更能查看多维度分析报告及解决方案。</p>
                </div>
              </li>
              <li>
                <div class="pro-intro">
                  <img src="../assets/img/aRZ_pic07.jpg">
                </div>
                <div class="pro-introtxt">
                  <h4>吾征高血糖智能认知仪</h4>
                  <p>不只是一个“血糖测量仪”！</p>
                  <p>我们在测量用户血糖数据同时，对用户血糖数据进行智能认知分析，结合用户身体情况做出预警提醒，通过吾征AI APP更能查看多维度分析报告及解决方案。</p>
                </div>
              </li>
              <li>
                <div class="pro-intro">
                  <img src="../assets/img/aRZ_pic08.jpg">
                </div>
                <div class="pro-introtxt">
                  <h4>吾征智能三合一</h4>
                  <p>不只是一个“测量仪”！</p>
                  <p>“吾征智能三合一”一次测量三种数据（血糖、总胆固醇、血尿酸），我们在测量用户健康数据同时，对用户血糖、总胆固醇及血尿酸数据进行智能认知分析，结合用户身体情况做出预警提醒，通过吾征AI APP更能查看多维度分析报告及解决方案。</p>
                </div>
              </li>
              <li>
                <div class="pro-intro">
                  <img src="../assets/img/aRZ_pic09.jpg">
                </div>
                <div class="pro-introtxt">
                  <h4>智能认知血糖仪高端礼盒</h4>
                  <p>为您提供血糖健康管理方案，通过吾征智能血糖仪随时监测身体血糖信息，借助智能认知技术对您进行血糖预警管理并提供膳食解决方案。</p>
                  <p>产品包括1台吾征智能血糖仪和4盒共2KG适合糖尿病人食用的53°大米及吾征年度会员卡一张。</p>
                </div>
              </li>
              <li>
                <div class="pro-intro">
                  <img src="../assets/img/aRZ_pic10.jpg">
                </div>
                <div class="pro-introtxt">
                  <h4>智能认知血脂仪高端礼盒</h4>
                  <p>为您提供血脂健康管理方案，通过吾征智能血脂仪随时监测身体血脂信息，借助智能认知技术对您进行血脂预警管理并提供膳食解决方案。</p>
                  <p>产品包括1台吾征智能血脂仪和4盒共2KG可以降血脂的的红曲米及吾征年度会员卡一张。</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <!-- 侏罗纪智能认知芯片 -->
      <section class="content-wrap section bot8">
        <div class="content-w">
          <div class="content-txt" style="display: none;">侏罗纪智能认知芯片</div>
          <h3><span>侏罗纪AIOT智能认知芯片</span></h3>
          <ul class="cont-list list4">
            <li>
              <div class="cont-list-info">
                <div class=""><img src="../assets/img/prod_pic11.jpg"></div>
                <h5>侏罗纪AIOT智能认知芯片</h5>
              </div>
            </li>
            <li>
              <div class="cont-list-info">
                <div class=""><img src="../assets/img/prod_pic12.jpg"></div>
                <h5>医疗级2G温度采集器</h5>
              </div>
            </li>
            <li>
              <div class="cont-list-info">
                <div class=""><img src="../assets/img/prod_pic13.jpg"></div>
                <h5>医疗级无线通信DTU</h5>
              </div>
            </li>
            <li>
              <div class="cont-list-info">
                <div class=""><img src="../assets/img/prod_pic14.jpg"></div>
                <h5>医疗级四路控制器</h5>
              </div>
            </li>
          </ul>
        </div>
      </section>
    </div>
    <app-footer />
  </div>
</template>

<script>
import header from '@/components/header'
import footer from '@/components/footer'



export default {
  data () {
    return {

    }
  },
  components: {
    'app-header': header,
    'app-footer': footer,
  },
  methods: {
    returnGo () {
      this.$router.go(0);
    },
    Scroll () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 400) {
        //$('.header-1').fadeIn("slow");
        $(".pageScroll").addClass("pageshow");
      } else if (scrollTop < 400) {
        $(".pageScroll").removeClass("pageshow");
      }
    },
  },
  mounted () {
    var navLabel = new Array('平台', '产品', "芯片");
    $('#main').pageScroller({ navigation: navLabel });
    $('.next').click(function (e) {
      e.preventDefault();
      pageScroller.next();
    });
    $('.prev').click(function (e) {
      e.preventDefault();
      pageScroller.prev();
    });

    document.addEventListener('scroll', this.Scroll, true);
    $(".z-ai-tab span").click(function () {
      $(".z-ai-tab span").eq($(this).index()).addClass("active").siblings().removeClass('active');
      $(".z-ai-list").eq($(".z-ai-tab span").index(this)).addClass("zshow").siblings().removeClass('zshow');
    });
    var jq = $;


    jq.fn.banqh = function (can) {
      can = jq.extend({
        picwrap: null,//总框架
        pic: null,//大图框架
        pnum: null,//小图框架
        prev_btn: null,//小图左箭头
        next_btn: null,//小图右箭头
        pop_prev: null,//弹出框左箭头
        pop_next: null,//弹出框右箭头
        //delayTime:800,//切换一张图片时间
        order: 0,//当前显示的图片（从0开始）
        picdire: true,//大图滚动方向（true水平方向滚动）
        mindire: true,//小图滚动方向（true水平方向滚动）
        min_picnum: null,//小图显示数量
      }, can || {});
      var picnum = jq(can.pic).find('ul li').length;
      var picw = jq(can.pic).find('ul li').outerWidth(true);
      var pich = jq(can.pic).find('ul li').outerHeight(true);
      var picminnum = jq(can.pnum).find('ul li').length;
      var picminw = jq(can.pnum).find('ul li').outerWidth(true);
      var picminh = jq(can.pnum).find('ul li').outerHeight(true);
      var tpqhnum = 0;
      var xtqhnum = 0;
      jq(can.pic).find('ul').width(picnum * picw);
      jq(can.pnum).find('ul').width(picminnum * picminw);

      //点击小图切换大图
      jq(can.pnum).find('li').click(function () {
        tpqhnum = xtqhnum = jq(can.pnum).find('li').index(this);
        show(tpqhnum);
        minshow(xtqhnum);
      }).eq(can.order).trigger("click");

      //小图左右      
      jq(can.prev_btn).click(function () {
        if (tpqhnum == 0) { tpqhnum = picnum };
        if (xtqhnum == 0) { xtqhnum = picnum };
        xtqhnum--;
        tpqhnum--;
        show(tpqhnum);
        minshow(xtqhnum);
      })
      jq(can.next_btn).click(function () {
        if (tpqhnum == picnum - 1) { tpqhnum = -1 };
        if (xtqhnum == picminnum - 1) { xtqhnum = -1 };
        xtqhnum++;
        minshow(xtqhnum)
        tpqhnum++;
        show(tpqhnum);
      })

      //小图切换
      function minshow (xtqhnum) {
        var mingdjl_num = xtqhnum - can.min_picnum + 2
        var mingdjl_w = -mingdjl_num * picminw;
        var mingdjl_h = -mingdjl_num * picminh;

        if (can.mindire == true) {
          //jq(can.pnum).find('ul li').css('float','left');
          if (picminnum > can.min_picnum) {
            if (xtqhnum < 4) { mingdjl_w = 0; }
            if (xtqhnum == picminnum - 1) { mingdjl_w = -(mingdjl_num - 1) * picminw; }
            jq(can.pnum).find('ul').stop().animate({ 'left': mingdjl_w }, can.delayTime);
          }

        } else {
          jq(can.pnum).find('ul li').css('float', 'none');
          if (picminnum > can.min_picnum) {
            if (xtqhnum < 4) { mingdjl_h = 0; }
            if (xtqhnum == picminnum - 1) { mingdjl_h = -(mingdjl_num - 1) * picminh; }
            jq(can.pnum).find('ul').stop().animate({ 'top': mingdjl_h }, can.delayTime);
          }
        }

      }
      //大图切换
      function show (tpqhnum) {
        var gdjl_w = -tpqhnum * picw;
        var gdjl_h = -tpqhnum * pich;
        if (can.picdire == true) {
          //jq(can.pic).find('ul li').css('float','left');
          jq(can.pic).find('ul').stop().animate({ 'left': gdjl_w }, can.delayTime);
        } else {
          jq(can.pic).find('ul').stop().animate({ 'top': gdjl_h }, can.delayTime);
        }//滚动
        //jq(can.pic).find('ul li').eq(tpqhnum).fadeIn(can.delayTime).siblings('li').fadeOut(can.delayTime);//淡入淡出
        jq(can.pnum).find('li').eq(tpqhnum).addClass("on").siblings(this).removeClass("on");
      };
    }




    jq('#proinfo').banqh({
      picwrap: "#proinfo",//总框架
      pic: "#ban_pic1",//大图框架
      pnum: "#ban_num1",//小图框架
      prev_btn: "#prev_btn1",//小图左箭头
      next_btn: "#next_btn1",//小图右箭头
      order: 0,//当前显示的图片（从0开始）
      min_picnum: 6,//小图显示数量
    })

    $('.cont-list li').hover(function () {
      $('.cont-list-main', this).stop().animate({
        height: '280px'
      });
    }, function () {
      $('.cont-list-main', this).stop().animate({
        height: '0'
      });
    });






  },
}
</script>
<style scoped>
@import "../assets/css/product.css";

.Ppictxt {
  width: 1334px;
  height: 163px;
  margin: 0 auto;
  background: url(../assets/images/product_Picturetext.png) no-repeat center;
  margin-top: 230px;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/product.vue